import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-section-shell-form',
  templateUrl: './section-shell-form.component.html',
  styleUrl: './section-shell-form.component.scss',
})
export class SectionShellFormComponent {
     readonly title = input.required<string>();
     readonly info = input<string>();
}
